import { render, staticRenderFns } from "./CBCSearchSideBar.vue?vue&type=template&id=2d9d7bec"
import script from "./CBCSearchSideBar.vue?vue&type=script&lang=js"
export * from "./CBCSearchSideBar.vue?vue&type=script&lang=js"
import style0 from "./CBCSearchSideBar.vue?vue&type=style&index=0&id=2d9d7bec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports